import classNames from 'classnames'
import Button from 'components/forms/Button'

import styles from './styles/SettingsButton.css'

export const SettingsButton = ({
  className,
  toggle
}) => (
  <Button className={styles.btn} onClick={toggle} aria-label='Settings button' tiny>
    <i className={classNames(styles.icon, className)} />
    <span className={styles.text}>Settings</span>
  </Button>
)

export default SettingsButton
